import React, { useEffect, useState } from 'react';
import {
    Box, Button, FormControl, InputLabel, MenuItem, Paper,
    Select, TextField, Typography, CircularProgress, Checkbox,
    FormControlLabel, Grid, 
    // Backdrop // Add Backdrop here
} from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import apiClient from '../../utils/apiClient';

const AddEditVehicleModel = () => {
    const [formData, setFormData] = useState({
        brandId: '',
        modelName: '',
        modelImage: null,
        isActive: true,
    });
    const [brands, setBrands] = useState([]);
    const [loading, setLoading] = useState(false);
    const [previewImage, setPreviewImage] = useState(null);

    const navigate = useNavigate();
    const location = useLocation();
    const editData = location.state;
    const isEdit = !!editData;
    const [error, setError] = useState('')

    useEffect(() => {
        const fetchBrands = async () => {

            try {
                const res = await apiClient.get(`/vehiclebrand/getallbrands`);
                setBrands(res.data.brands || []);
            } catch (err) {
                setError(err?.response?.data?.message || "Failed to load brands");
            }
        };

        fetchBrands();

        if (isEdit) {
            setFormData({
                brandId: editData.brandId || '',
                modelName: editData.modelName || '',
                modelImage: null,
                isActive: editData.isActive ?? true
            });
            setPreviewImage(editData.modelLogo || null);
        }
    }, [isEdit, editData]);

    const handleChange = (e) => {
        setFormData(prev => ({
            ...prev,
            [e.target.name]: e.target.value
        }));
    };

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setFormData(prev => ({
                ...prev,
                modelImage: file
            }));
            setPreviewImage(URL.createObjectURL(file));
        }
    };

    const handleCheckboxChange = (e) => {
        setFormData(prev => ({
            ...prev,
            isActive: e.target.checked
        }));
    };

//     const handleSubmit = async () => {
//         const { brandId, modelName, modelImage, isActive } = formData;

//         if (!brandId || !modelName || (!isEdit && !modelImage)) {
//             setError('Please fill all required fields.');
//             return;
//         }

//         const payload = new FormData();
//         payload.append('brandId', brandId);
//         payload.append('modelName', modelName);
//         payload.append('isActive', isActive);
//         if (modelImage) payload.append('modelImage', modelImage);

//         try {
//             setLoading(true);

//             if (isEdit) {
//                 // const res = await axios.put(`${apiUrl}/brandmodel/updatebrandmodel/${editData.id}`, payload, {
//                 //     headers: { 'Content-Type': 'multipart/form-data' }
//                 // });
//                 const res = await axios.put(
//   `${apiUrl}/brandmodel/updatebrandmodel/${editData.id}`,
//   payload,
//   {
//     headers: {
//       'Content-Type': 'multipart/form-data',
//       Authorization: `Bearer ${token}` // 👈 add your token here
//     }
//   }
// );
//                 if (res.data.status === true) {
//                     toast.success(res.data.message)
//                     navigate('/display-vehicle-models');
//                 }
//             } else {
//                 // const res = await axios.post(`${apiUrl}/brandmodel/createbrandmodel`, payload, {
//                 //     headers: { 'Content-Type': 'multipart/form-data' }
//                 // });
//                 const res = await axios.post(
//   `${apiUrl}/brandmodel/createbrandmodel`,
//   payload,
//   {
//     headers: {
//       "Content-Type": "multipart/form-data",
//       Authorization: `Bearer ${token}`
//     }
//   }
// );
//                 if (res.data.status === true) {
//                     toast.success(res.data.message)
//                     navigate('/display-vehicle-models');
//                 }
//             }
//         } catch (err) {
//             setError("Submission failed:", err);
//         } finally {
//             setLoading(false);
//         }
//     };

const handleSubmit = async () => {
    if (loading) return; // Prevent double submission

    const { brandId, modelName, modelImage, isActive } = formData;

    if (!brandId || !modelName || (!isEdit && !modelImage)) {
        setError('Please fill all required fields.');
        return;
    }

    const payload = new FormData();
    payload.append('brandId', brandId);
    payload.append('modelName', modelName);
    payload.append('isActive', isActive);
    if (modelImage) payload.append('modelImage', modelImage);

    try {
        setLoading(true);
        setError(''); // Clear previous errors

        let res;
        if (isEdit) {
            res = await apiClient.put(
                `/brandmodel/updatebrandmodel/${editData.id}`,
                payload,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            );
        } else {
            res = await apiClient.post(
                `/brandmodel/createbrandmodel`,
                payload,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            );
        }

        if (res.data.status === true) {
            toast.success(res.data.message);
            navigate('/display-vehicle-models');
        } else {
            setError(res.data.message || 'Submission failed.');
        }
    } catch (err) {
        setError(err.response?.data?.message || err.message || 'Submission failed.');
    } finally {
        setLoading(false);
    }
};
    return (
        <Box sx={{ maxWidth: 500, mr: 'auto', mt: 4, p: 3 }}>
            <Paper sx={{ p: 3 }}>
                <Typography variant="h5" mb={3} align="center">
                    {isEdit ? 'Edit Vehicle Model' : 'Add Vehicle Model'}
                </Typography>
                <Grid container spacing={2}>
                    <Grid item size={12}>
                        <FormControl fullWidth size="small">
                            <InputLabel id="brand-label">Select Brand</InputLabel>
                            <Select
                                labelId="brand-label"
                                name="brandId"
                                value={formData.brandId}
                                label="Select Brand"
                                onChange={handleChange}
                                disabled={loading} // Optional: Disable during loading
                            >
                                {brands.map((brand) => (
                                    <MenuItem key={brand.id} value={brand.id}>
                                        {brand.brandName}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item size={12}>
                        <TextField
                            fullWidth
                            size="small"
                            name="modelName"
                            label="Model Name"
                            value={formData.modelName}
                            onChange={handleChange}
                            disabled={loading} // Optional: Disable during loading
                        />
                    </Grid>
                    <Grid item size={12}>
                        <Button variant="contained" component="label" fullWidth disabled={loading}>
                            Upload Model Image
                            <input
                                type="file"
                                accept="image/*"
                                hidden
                                onChange={handleImageChange}
                                disabled={loading} // Optional: Disable during loading
                            />
                        </Button>
                    </Grid>
                    {previewImage && (
                        <Grid item size={12} sx={{ textAlign: "center" }}>
                            {formData.modelImage && (
                                <Typography variant="body2" mb={1}>
                                    Selected: {formData.modelImage.name}
                                </Typography>
                            )}
                            <Box
                                component="img"
                                src={previewImage}
                                alt="Model Preview"
                                sx={{
                                    width: 120,
                                    height: 120,
                                    objectFit: 'cover',
                                    border: '1px solid #ccc',
                                    borderRadius: 1,
                                    mt: 1
                                }}
                            />
                        </Grid>
                    )}
                    <Grid item size={12}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={formData.isActive}
                                    onChange={handleCheckboxChange}
                                />
                            }
                            label="Active"
                        />
                    </Grid>
                    <Grid item size={12}>
                        {error &&

                        <Typography variant='body2' color='error'>{error}</Typography>
                        }
                    </Grid>
                    <Grid item size={12} display="flex" gap={2} justifyContent="flex-end">
                        <Button
                            variant="contained"
                            onClick={handleSubmit}
                            disabled={loading}
                        >
                            {loading ? <CircularProgress size={20} /> : 'Submit'}
                        </Button>
                        <Button
                            variant="outlined"
                            onClick={() => navigate(-1)}
                            disabled={loading} // Optional: Disable during loading
                        >
                            Cancel
                        </Button>
                    </Grid>
                </Grid>
            </Paper>
            {/* Add Backdrop loader */}
            {/* <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={loading}
            >
                <CircularProgress color="inherit" />
            </Backdrop> */}
        </Box>
    );
};

export default AddEditVehicleModel;
